import {
    Model
} from '@vuex-orm/core'

export default class User extends Model {
    static entity = 'users'

    static fields() {
        return {
            id: this.attr(null),
            first_name: this.attr(null),
            last_name: this.attr(null),
            profile_url: this.attr(null)
        }
    }
    static showGroupUsers(group_id, page = 1, limit = 999) {
        return this.api().get(`/groups/${group_id}/users`, {
            params: {
                page: page,
                limit: limit

            },
            dataTransformer: (response) => {
                let storageArray = []
                response.data.data.forEach(element => {
                    let target = element
                    Object.assign(target, target.attributes)
                    element.id = parseInt(element.id)
                    storageArray.push(target)
                })

                return storageArray
            }
        })
    }

}
